import { Filter } from '../../common/types';

export type PageMetaData = {
  PageNumber: number;
  PageSize: number;
};

export type InvoiceRequestBody = {
  filter: Filter;
  pageMetaData: PageMetaData;
};

export const InvoiceShareMap = new Map([
  ['invoiceNumber','Invoice Number'],
  ['invoiceDate','Invoice Date'],
  ['invoiceStatus','Invoice Status'],
  ['buyerName','Buyer Name'],
  ['totalInvoiceValue','Total Invoice value']
]);


